export function isHttpOrHttpsUrl(urlString: string) {
  try {
    const url = new URL(urlString)
    return url.protocol === "https:" || url.protocol === "http:"
  } catch {
    return false
  }
}
